import { createApp } from "vue";
import App from "./App.vue";
import axios from "axios";
import VueAxios from "vue-axios";
import routes from "./routes/routes.js";
import { createRouter, createWebHashHistory } from "vue-router";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import moment from "moment";
import "./assets/variables.scss";
import ClickOutside from './directives/ClickOutsideDirective.js' // Adjust the import path according to your project structure
import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import sk from './locales/sk.json'
import cs from './locales/cs.json'

const locale = process.env.VUE_APP_LOCALE || 'cs';

console.log(`Setting application locale to ${locale}`);

// Slavic 4-arm rule: 0 / 1 / 2-4 / 5+ — Czech and Slovak share the same shape.
// Registered against vue-i18n so the pipe-syntax plural keys (e.g.
// `no persons | {count} person | {count} persons | {count} persons (5+)`)
// select the right arm by count instead of hardcoding the band in JS.
const slavicPluralRule = (choice) => {
    if (choice === 0) return 0;
    if (choice === 1) return 1;
    if (choice >= 2 && choice <= 4) return 2;
    return 3;
};

export const i18n = createI18n({
    locale: locale,
    fallbackLocale: 'en',
    messages: {
        en,
        sk,
        cs
    },
    pluralizationRules: {
        cs: slavicPluralRule,
        sk: slavicPluralRule,
    },
})

moment.locale(locale);

const router = createRouter({
  // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
  history: createWebHashHistory(),
  routes, // short for `routes: routes`
});

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);
app.use(VueAxios, axios)
    .use(i18n)
    .provide("axios", app.config.globalProperties.axios)
    .use(router)
    .use(pinia)
    .directive('click-outside', ClickOutside)
    .mount("#app");
